module.exports = "/lucky-balls/img/bigball/BigBall_006.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_006.png
// module id = 901
// module chunks = 0